export const phaseOut = (div: string = "appPaper") => {
  document.getElementById(div)?.classList.add("mfhidden");
};

export const phaseIn = (div: string = "appPaper") => {
  document.getElementById("appPaper")?.scrollTo(0, 0);
  document.getElementById(div)?.classList.remove("mfhidden");
};
